import { render, staticRenderFns } from "./ModalSelectProduct.vue?vue&type=template&id=1b04099c"
import script from "./ModalSelectProduct.vue?vue&type=script&lang=js"
export * from "./ModalSelectProduct.vue?vue&type=script&lang=js"
import style0 from "./ModalSelectProduct.vue?vue&type=style&index=0&id=1b04099c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports